import { BarCodeType } from "./type"

export const barcodes: BarCodeType[] = [
    "qrcode",
    "ean13",
    "ean8",
    "japanpost",
    "code39",
    "code128",
    "nw7",
    "itf14",
    "upca",
    "upce",
];